<!-- prettier-ignore -->

<div class="day-selection-container">
    @for (day of days(); track day; let dayIndex = $index) {
        <button (click)="selectDay(dayIndex)" [ngStyle]="{'background': primaryColors[dayIndex]}">{{ 'Día' | translate }} {{ dayIndex + 1 }}</button>
    }
</div>